// ===== ClasseForm.js =====
import React, { useState, useEffect } from 'react';

const ClasseForm = ({ classe, onSave, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    code: '',
    libelle: '',
    description: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (classe) {
      setFormData({
        code: classe.code || '',
        libelle: classe.libelle || '',
        description: classe.description || ''
      });
    }
  }, [classe]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.code.trim()) {
      newErrors.code = 'Le code est obligatoire';
    } else if (!/^[1-9]$/.test(formData.code)) {
      newErrors.code = 'Le code doit être un chiffre de 1 à 9';
    }

    if (!formData.libelle.trim()) {
      newErrors.libelle = 'Le libellé est obligatoire';
    } else if (formData.libelle.length > 200) {
      newErrors.libelle = 'Le libellé ne peut pas dépasser 200 caractères';
    }

    if (formData.description && formData.description.length > 500) {
      newErrors.description = 'La description ne peut pas dépasser 500 caractères';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSave(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Effacer l'erreur du champ modifié
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Code */}
      <div>
        <label htmlFor="code" className="block text-sm font-medium text-gray-700">
          Code classe (1-9) *
        </label>
        <input
          type="text"
          id="code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          disabled={!!classe} // Le code ne peut pas être modifié
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 ${
            errors.code ? 'border-red-300' : ''
          } ${classe ? 'bg-gray-100' : ''}`}
          placeholder="Ex: 1"
          maxLength={1}
        />
        {errors.code && <p className="mt-1 text-sm text-red-600">{errors.code}</p>}
        {classe && (
          <p className="mt-1 text-sm text-gray-500">Le code ne peut pas être modifié</p>
        )}
      </div>

      {/* Libellé */}
      <div>
        <label htmlFor="libelle" className="block text-sm font-medium text-gray-700">
          Libellé *
        </label>
        <input
          type="text"
          id="libelle"
          name="libelle"
          value={formData.libelle}
          onChange={handleChange}
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 ${
            errors.libelle ? 'border-red-300' : ''
          }`}
          placeholder="Ex: Comptes de ressources durables"
          maxLength={200}
        />
        {errors.libelle && <p className="mt-1 text-sm text-red-600">{errors.libelle}</p>}
        <p className="mt-1 text-sm text-gray-500">
          {formData.libelle.length}/200 caractères
        </p>
      </div>

      {/* Description */}
      <div>
        <label htmlFor="description" className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows={3}
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 ${
            errors.description ? 'border-red-300' : ''
          }`}
          placeholder="Description optionnelle de la classe..."
          maxLength={500}
        />
        {errors.description && <p className="mt-1 text-sm text-red-600">{errors.description}</p>}
        <p className="mt-1 text-sm text-gray-500">
          {formData.description.length}/500 caractères
        </p>
      </div>

      {/* Boutons */}
      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          disabled={loading}
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Enregistrement...' : classe ? 'Modifier' : 'Créer'}
        </button>
      </div>
    </form>
  );
};

// Exports
export default ClasseForm;